var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Ticker from '@marketing/components/sections/non_product/Ticker';
import { clsx } from 'clsx';
function useTicker(Component, text, backgroundColorStyle, theme, borderColorStyleOverride) {
    var borderColorStyle = borderColorStyleOverride ||
        (theme === 'dark' ? 'border-state-inactive-light' : 'border-state-inactive-dark');
    var textStyle = theme === 'dark' ? 'text-text-white' : 'text-text-body';
    return (_jsxs("div", { children: [_jsx("div", __assign({ className: clsx('border-b', borderColorStyle, textStyle) }, { children: _jsx(Ticker, { text: text, backgroundColorStyle: backgroundColorStyle, theme: theme }) })), Component] }));
}
export default useTicker;
